/**
 * Standardní identifikátory sloužící jako klíč položek pro registraci v DI konktejneru
 * @includeToDoc
 */
export class DIIdentifiers {
}
